<script>
import VueMarkdown from 'vue-markdown-render';
import MarkdownItLinkAttributes from 'markdown-it-link-attributes';

function markdownPluginWithOptions(plugin, options) {
  return (instance) => instance.use(plugin, options);
}

const MARKDOWN_IT_PLUGINS = [
  markdownPluginWithOptions(MarkdownItLinkAttributes, [
    {
      matcher: (href) => /^https?:\/\//.test(href),
      attrs: {
        target: '_blank',
        rel: 'noopener',
      },
    },
  ]),
];

export default {
  name: 'Markdown',
  components: {
    VueMarkdown,
  },
  props: {
    content: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      MARKDOWN_IT_PLUGINS,
    };
  },
  mounted() {
    const markdownContainerRef = this.$refs.markdownContainer;
    if (markdownContainerRef) {
      markdownContainerRef.addEventListener('click', this.handleLinkClick);
    }
  },
  beforeUnmount() {
    const markdownContainerRef = this.$refs.markdownContainer;
    if (markdownContainerRef) {
      markdownContainerRef.removeEventListener('click', this.handleLinkClick);
    }
  },
  methods: {
    handleLinkClick(event) {
      const anchor = event.target.closest('a');
      if (!anchor) {
        return;
      }
      const href = anchor.getAttribute('href');
      if (href && href.startsWith('/')) {
        const hrefWithoutLeadingHash = href.replace('/#', '');
        event.preventDefault();
        this.$router.push(hrefWithoutLeadingHash);
      }
    },
  },
};
</script>

<template>
  <div ref="markdownContainer">
    <vue-markdown :source="content" :plugins="MARKDOWN_IT_PLUGINS" />
  </div>
</template>

<style lang="scss" scoped>
/* Reset default settings added by the browser */
:deep(div),
:deep(ul),
:deep(ol) {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0;
}

:deep(p),
:deep(span),
:deep(li) {
  margin: 0;
  font-size: map.get($text-size-standard, 2);
  font-weight: map.get($text-weights, 'regular');
  line-height: map.get($text-line-height-standard, 2);
}

:deep(strong),
:deep(em) {
  margin: 0;
  display: inline;
}

:deep(a) {
  cursor: pointer;
  margin: 0;
  display: inline;
}

:deep(ul),
:deep(ol) {
  list-style-type: disc;
}

:deep(h1),
:deep(h2),
:deep(h3) {
  font-size: 0.85rem;
  font-weight: 700;
  margin: 0;
}

:deep(table) {
  border-spacing: 0;
  border: 1px solid var(--border-neutral);
  border-radius: 16px;
  overflow: hidden;
}

:deep(thead) {
  border-bottom: 1px solid var(--border-neutral);
}

:deep(tbody) {
  background-color: var(--base);
}

:deep(th) {
  background-color: var(--surface-neutral);
  color: var(--text-neutral-bold);
  padding: 0.5rem;
  font-size: map.get($text-size-standard, 2);
  font-weight: map.get($text-weights, 'medium');
  line-height: map.get($text-line-height-standard, 2);
  border-bottom: 1px solid var(--border-neutral);
}

:deep(tbody tr),
:deep(tr:not(:last-child) td) {
  border-bottom: 1px solid var(--border-neutral);
}

:deep(td) {
  background-color: var(--base);
  padding: 0.5rem;
  font-size: map.get($text-size-standard, 2);
  font-weight: map.get($text-weights, 'regular');
  line-height: map.get($text-line-height-standard, 2);
}
</style>
